module.exports = __webpack_public_path__ + "media/scholarship_winners/christopher-j-a01c35aa.png";